export default __webpack_public_path__ + "static/media/seiko-logo.e263d55b.svg";